export default Object.freeze({
  SURVEY_BACKGROUND_IMAGE: 'SURVEY_BACKGROUND_IMAGE',
  QUESTION_IMAGE: 'QUESTION_IMAGE'
});
